/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getIncomingPurchaseLists } from '../fn/purchase-lists/get-incoming-purchase-lists';
import { GetIncomingPurchaseLists$Params } from '../fn/purchase-lists/get-incoming-purchase-lists';
import { getOutgoingPurchaseLists } from '../fn/purchase-lists/get-outgoing-purchase-lists';
import { GetOutgoingPurchaseLists$Params } from '../fn/purchase-lists/get-outgoing-purchase-lists';
import { getPurchaseById } from '../fn/purchase-lists/get-purchase-by-id';
import { GetPurchaseById$Params } from '../fn/purchase-lists/get-purchase-by-id';
import { getPurchaseDetails } from '../fn/purchase-lists/get-purchase-details';
import { GetPurchaseDetails$Params } from '../fn/purchase-lists/get-purchase-details';
import { getPurchaseItemById } from '../fn/purchase-lists/get-purchase-item-by-id';
import { GetPurchaseItemById$Params } from '../fn/purchase-lists/get-purchase-item-by-id';
import { listAllPurchases } from '../fn/purchase-lists/list-all-purchases';
import { ListAllPurchases$Params } from '../fn/purchase-lists/list-all-purchases';
import { listAllPurchasesByMerchantId } from '../fn/purchase-lists/list-all-purchases-by-merchant-id';
import { ListAllPurchasesByMerchantId$Params } from '../fn/purchase-lists/list-all-purchases-by-merchant-id';
import { listItemsOfPurchaseById } from '../fn/purchase-lists/list-items-of-purchase-by-id';
import { ListItemsOfPurchaseById$Params } from '../fn/purchase-lists/list-items-of-purchase-by-id';
import { PagedModelPurchaseAdminResponseModel } from '../models/paged-model-purchase-admin-response-model';
import { PagedModelPurchaseItemAdminResponseModel } from '../models/paged-model-purchase-item-admin-response-model';
import { PageIncomingPurchaseListResponse } from '../models/page-incoming-purchase-list-response';
import { PageOutgoingPurchaseListResponse } from '../models/page-outgoing-purchase-list-response';
import { PurchaseAdminResponseModel } from '../models/purchase-admin-response-model';
import { PurchaseDto } from '../models/purchase-dto';
import { PurchaseItemAdminResponseModel } from '../models/purchase-item-admin-response-model';
import { updatePurchaseListStatus } from '../fn/purchase-lists/update-purchase-list-status';
import { UpdatePurchaseListStatus$Params } from '../fn/purchase-lists/update-purchase-list-status';


/**
 * Purchase administration endpoints. All operations require EASYLOT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class PurchaseListsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updatePurchaseListStatus()` */
  static readonly UpdatePurchaseListStatusPath = '/purchase-lists/status';

  /**
   * Updates the status of purchase list.
   *
   * Updates the status of purchase list based on the provided id and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePurchaseListStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseListStatus$Response(params: UpdatePurchaseListStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updatePurchaseListStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of purchase list.
   *
   * Updates the status of purchase list based on the provided id and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePurchaseListStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseListStatus(params: UpdatePurchaseListStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updatePurchaseListStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllPurchases()` */
  static readonly ListAllPurchasesPath = '/purchases';

  /**
   * Lists all purchases (admin).
   *
   * Returns a paginated list of all purchases across all merchants. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllPurchases()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllPurchases$Response(params: ListAllPurchases$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelPurchaseAdminResponseModel>> {
    const obs = listAllPurchases(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists all purchases (admin).
   *
   * Returns a paginated list of all purchases across all merchants. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllPurchases$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllPurchases(params: ListAllPurchases$Params, context?: HttpContext): Observable<PagedModelPurchaseAdminResponseModel> {
    const resp = this.listAllPurchases$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelPurchaseAdminResponseModel>): PagedModelPurchaseAdminResponseModel => r.body)
    );
  }

  /** Path part for operation `getPurchaseById()` */
  static readonly GetPurchaseByIdPath = '/purchases/{purchaseId}';

  /**
   * Gets a purchase by ID (admin).
   *
   * Returns details of the specified purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseById$Response(params: GetPurchaseById$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseAdminResponseModel>> {
    const obs = getPurchaseById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a purchase by ID (admin).
   *
   * Returns details of the specified purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseById(params: GetPurchaseById$Params, context?: HttpContext): Observable<PurchaseAdminResponseModel> {
    const resp = this.getPurchaseById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseAdminResponseModel>): PurchaseAdminResponseModel => r.body)
    );
  }

  /** Path part for operation `listItemsOfPurchaseById()` */
  static readonly ListItemsOfPurchaseByIdPath = '/purchases/{purchaseId}/items';

  /**
   * Lists items of a purchase (admin).
   *
   * Returns a paginated list of all line items belonging to the specified purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listItemsOfPurchaseById()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsOfPurchaseById$Response(params: ListItemsOfPurchaseById$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelPurchaseItemAdminResponseModel>> {
    const obs = listItemsOfPurchaseById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists items of a purchase (admin).
   *
   * Returns a paginated list of all line items belonging to the specified purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listItemsOfPurchaseById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsOfPurchaseById(params: ListItemsOfPurchaseById$Params, context?: HttpContext): Observable<PagedModelPurchaseItemAdminResponseModel> {
    const resp = this.listItemsOfPurchaseById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelPurchaseItemAdminResponseModel>): PagedModelPurchaseItemAdminResponseModel => r.body)
    );
  }

  /** Path part for operation `getPurchaseItemById()` */
  static readonly GetPurchaseItemByIdPath = '/purchases/{purchaseId}/items/{purchaseItemId}';

  /**
   * Gets a purchase item by ID (admin).
   *
   * Returns details of the specified line item within a purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseItemById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseItemById$Response(params: GetPurchaseItemById$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseItemAdminResponseModel>> {
    const obs = getPurchaseItemById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a purchase item by ID (admin).
   *
   * Returns details of the specified line item within a purchase. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseItemById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseItemById(params: GetPurchaseItemById$Params, context?: HttpContext): Observable<PurchaseItemAdminResponseModel> {
    const resp = this.getPurchaseItemById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseItemAdminResponseModel>): PurchaseItemAdminResponseModel => r.body)
    );
  }

  /** Path part for operation `getPurchaseDetails()` */
  static readonly GetPurchaseDetailsPath = '/purchase-lists/{purchaseId}';

  /**
   * Gets purchase details.
   *
   * Returns the details of the specified purchase for the authenticated merchant. Requires PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseDetails$Response(params: GetPurchaseDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseDto>> {
    const obs = getPurchaseDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets purchase details.
   *
   * Returns the details of the specified purchase for the authenticated merchant. Requires PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseDetails(params: GetPurchaseDetails$Params, context?: HttpContext): Observable<PurchaseDto> {
    const resp = this.getPurchaseDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseDto>): PurchaseDto => r.body)
    );
  }

  /** Path part for operation `getOutgoingPurchaseLists()` */
  static readonly GetOutgoingPurchaseListsPath = '/purchase-lists/outgoing';

  /**
   * Gets outgoing purchase lists.
   *
   * Returns paginated outgoing purchase lists for the authenticated merchant, filtered by progress status. Requires PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOutgoingPurchaseLists()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOutgoingPurchaseLists$Response(params: GetOutgoingPurchaseLists$Params, context?: HttpContext): Observable<StrictHttpResponse<PageOutgoingPurchaseListResponse>> {
    const obs = getOutgoingPurchaseLists(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets outgoing purchase lists.
   *
   * Returns paginated outgoing purchase lists for the authenticated merchant, filtered by progress status. Requires PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOutgoingPurchaseLists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOutgoingPurchaseLists(params: GetOutgoingPurchaseLists$Params, context?: HttpContext): Observable<PageOutgoingPurchaseListResponse> {
    const resp = this.getOutgoingPurchaseLists$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageOutgoingPurchaseListResponse>): PageOutgoingPurchaseListResponse => r.body)
    );
  }

  /** Path part for operation `getIncomingPurchaseLists()` */
  static readonly GetIncomingPurchaseListsPath = '/purchase-lists/incoming';

  /**
   * Gets incoming purchase lists.
   *
   * Returns paginated incoming purchase lists for the authenticated merchant, filtered by progress status. Requires PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIncomingPurchaseLists()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIncomingPurchaseLists$Response(params: GetIncomingPurchaseLists$Params, context?: HttpContext): Observable<StrictHttpResponse<PageIncomingPurchaseListResponse>> {
    const obs = getIncomingPurchaseLists(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets incoming purchase lists.
   *
   * Returns paginated incoming purchase lists for the authenticated merchant, filtered by progress status. Requires PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIncomingPurchaseLists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIncomingPurchaseLists(params: GetIncomingPurchaseLists$Params, context?: HttpContext): Observable<PageIncomingPurchaseListResponse> {
    const resp = this.getIncomingPurchaseLists$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageIncomingPurchaseListResponse>): PageIncomingPurchaseListResponse => r.body)
    );
  }

  /** Path part for operation `listAllPurchasesByMerchantId()` */
  static readonly ListAllPurchasesByMerchantIdPath = '/merchants/{merchantId}/purchases';

  /**
   * Lists all purchases for a merchant (admin).
   *
   * Returns a paginated list of all purchases belonging to the specified merchant. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllPurchasesByMerchantId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllPurchasesByMerchantId$Response(params: ListAllPurchasesByMerchantId$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelPurchaseAdminResponseModel>> {
    const obs = listAllPurchasesByMerchantId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists all purchases for a merchant (admin).
   *
   * Returns a paginated list of all purchases belonging to the specified merchant. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllPurchasesByMerchantId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllPurchasesByMerchantId(params: ListAllPurchasesByMerchantId$Params, context?: HttpContext): Observable<PagedModelPurchaseAdminResponseModel> {
    const resp = this.listAllPurchasesByMerchantId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelPurchaseAdminResponseModel>): PagedModelPurchaseAdminResponseModel => r.body)
    );
  }

}
